import React from "react";
import "./Loader.css";

export default function Loader() {
  return (
    <div className="global-loader">
      <div className="global-loader-spinner"></div>
    </div>
  );
}
